import request from '@/core/http/request'

// 查询采购订单
export function pmgtPurchasesOrderDoc_cooperativeSupplierPurchasesOrderDocList(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtPurchasesOrderDoc/cooperativeSupplierPurchasesOrderDocList',
    method: 'post',
    data: data
  })
}

// 采购订单详情
export function pmgtPurchasesOrderDoc_cooperativeSupplierPurchasesOrderDocView(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtPurchasesOrderDoc/cooperativeSupplierPurchasesOrderDocView',
    method: 'post',
    data: data
  })
}

// 采购订单打印
export function pmgtPurchasesOrderDocDetail_selectListForPrint(data) {
  return request({
    url: '/qingguang/tenantbussiness/pmgtPurchasesOrderDocDetail/selectListForPrint',
    method: 'get',
    params: data
  })
}

// 采购入库单列表
export function pmgtPurchasesReceiptDoc_cooperativeSupplierPurchasesReceiptDocList(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtPurchasesReceiptDoc/cooperativeSupplierPurchasesReceiptDocList',
    method: 'post',
    data: data
  })
}

// 采购入库订单详情
export function pmgtPurchasesReceiptDoc_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/pmgtPurchasesReceiptDoc/view',
    method: 'get',
    params: data
  })
}

// 采购入库单详情
export function pmgtPurchasesReceiptDoc_cooperativeSupplierPurchasesReceiptDocView(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtPurchasesReceiptDoc/cooperativeSupplierPurchasesReceiptDocView',
    method: 'post',
    data: data
  })
}

// 付款账单列表
export function pmgtPurchasesReceiptDoc_getCooperativeSupplierPurchaseStatementDocList(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtPurchasesStatementDoc/getCooperativeSupplierPurchaseStatementDocList',
    method: 'post',
    data: data
  })
}

// 付款账单详情
export function pmgtPurchasesReceiptDoc_getCooperativeSupplierPurchaseStatementDocView(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtPurchasesStatementDoc/getCooperativeSupplierPurchaseStatementDocView',
    method: 'post',
    data: data
  })
}

// 未对账列表
export function pmgtStatementPaymentDoc_getCooperativeSupplierStatementReceiptDocList(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtStatementPaymentDoc/getCooperativeSupplierStatementReceiptDocList',
    method: 'post',
    data: data
  })
}

// 新增发货数据
export function pmgtPurchasesReceiptDoc_add(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtPurchasesReceiptDoc/add',
    method: 'post',
    data: data
  })
}

// 查询可入库数据
export function pmgtPurchasesReceiptDocDetail_selectCooperativeSupplierPurchaseUnReceiptOrderList(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtPurchasesReceiptDocDetail/selectCooperativeSupplierPurchaseUnReceiptOrderList',
    method: 'post',
    data: data
  })
}

// 对账
export function pmgtPurchasesStatementDoc_supplierGenerationPaymentStatementWithStatementPaymentDoc(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtPurchasesStatementDoc/supplierGenerationPaymentStatementWithStatementPaymentDoc',
    method: 'post',
    data: data
  })
}

// 询价单列表
export function pmgtPurchasesInquiryCooperativeDoc_selectPurchaseInquiryCooperativeList(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtPurchasesInquiryCooperativeDoc/selectPurchaseInquiryCooperativeList',
    method: 'post',
    data: data
  })
}

// 询价单列表
export function pmgtPurchasesInquiryCooperativeDoc_view(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtPurchasesInquiryCooperativeDoc/view',
    method: 'post',
    data: data
  })
}

// 询价单回复
export function pmgtPurchasesInquiryCooperativeDoc_upddatePurchaseInquiryCooperativeSupplierWithQuotationUnitPrice(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtPurchasesInquiryCooperativeDoc/upddatePurchaseInquiryCooperativeSupplierWithQuotationUnitPrice',
    method: 'post',
    data: data
  })
}

// 系统供应商基本信息查询
export function supplier_view(data) {
  return request({
    url: '/qingguang/cooperativesupplier/supplier/view',
    method: 'get',
    params: data
  })
}

// 基本信息发布草稿
export function pmgtCooperateDraftDoc_add(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtCooperateDraftDoc/add',
    method: 'post',
    data: data
  })
}

// 基本信息草稿查询
export function pmgtCooperateDraftDoc_list(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtCooperateDraftDoc/list',
    method: 'post',
    data: data
  })
}

// 基本信息删除
export function pmgtCooperateDraftDoc_delete(data) {
  return request({
    url: '/qingguang/cooperativesupplier/pmgtCooperateDraftDoc/delete',
    method: 'post',
    data: data
  })
}
